var styleDataHash = "aad1dd9a";
const injectCss = () => {
  var css = `.DOm5A,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.cAcN-{width:100%}[dir] .cAcN-{margin:8px auto 0}.cAcN- .TruKd{height:1px}[dir] .cAcN- .TruKd{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.cAcN- .TruKd{width:100%}[dir] .cAcN- .TruKd{margin:0}}}@container (width < 640px){.cAcN- .TruKd{width:100%}[dir] .cAcN- .TruKd{margin:0}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_section_default = {
  "fontElementMap": "DOm5A",
  "whitespace": "cAcN-",
  "divider": "TruKd"
};
export {
  list_item_section_default as default,
  injectCss
};
//# sourceMappingURL=list-item-section-scss.js.map
